import { useMemo } from 'react'
import { usePermission } from '@/hooks/usePermission'
import type { ListingKind } from '@/types/listing'

const LOCATION_READ = 'asset-mgr:location:read'

/**
 * 按权限裁剪 kind。没有 `asset-mgr:location:read` 的人不能请求 COMPANY、VIRTUAL，
 * 带上就是 403，所以请求前去掉。全部被裁掉时回空数组：调用方不发请求，显示空态。
 * 不退回 RENTAL：只要地点的场景不能出现出租房。
 */
export function useAllowedListingKinds(kinds: readonly ListingKind[]): ListingKind[] {
  const { hasPermission } = usePermission()
  const canReadPlaces = hasPermission(LOCATION_READ)
  const kindsKey = kinds.join(',')
  return useMemo(() => {
    const wanted = (kindsKey ? kindsKey.split(',') : []) as ListingKind[]
    return canReadPlaces ? wanted : wanted.filter((kind) => kind === 'RENTAL')
  }, [kindsKey, canReadPlaces])
}
